import { render, staticRenderFns } from "./LocationConfigs.vue?vue&type=template&id=32d103f4&"
import script from "./LocationConfigs.vue?vue&type=script&lang=js&"
export * from "./LocationConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports